import React from 'react';
import working from './img/working.png'

export default class RightButtons extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sendingEmail:false,
            waiting:false
        }
    }


    sendDevisEmail() {
        this.setState({sendingEmail:true})
        this.props.container.sendDevisEmail(this.gotEmail.bind(this))
    }


    gotEmail() {
        this.setState({sendingEmail:false})
    }


    duplicateDevis() {
        this.props.api.post(
            {   action:'dup_test',
                id:this.props.devis._id.$oid
            }
        )
    }


    resync() {
        if ( !this.state.waiting ) {
            this.setState({waiting:true})
            const me = this
            this.props.api.post({
                action:'get_devis',
                resync:true, // This forces re-synchronization : calculates prices by contacting xenassur
                id:this.props.devis._id.$oid
            },
            ()=>{
                me.setState({waiting:false})
            })
        }
    }


    render() {
        const params = this.props.devis.params

        const emailButtonClass = 'button'+(this.state.sendingEmail?' disabled':'')
        const emailButton = ( this.props.devis.params.email&&this.props.devis.synchronized ) ? 
        <a className={emailButtonClass} onClick={this.sendDevisEmail.bind(this)}>Envoyer le devis à <br/>{this.props.devis.params.email}</a>
        : ''

        let adminButtons = []
        if ( this.props.api.isAdmin() ) {
            adminButtons.push(
                <a target="_blank" key="logs_tarifs" className="button" href={this.props.api.downloadLogs(this.props.devis._id.$oid,'logs_tarifs')}>Logs tarifs</a>
            )
            if ( params.nom ) {
                adminButtons.push(
                    <a target="_blank" key="logs_devis" className="button" href={this.props.api.downloadLogs(this.props.devis._id.$oid,'logs_devis')}>Logs devis</a>
                )    
            }

            if ( this.props.devis.screenshots != 'ongoing' ) {
                adminButtons.push(
                    <a target="_blank" key="logs_screenshots" className="button" href={this.props.api.downloadLogs(this.props.devis._id.$oid,'logs_subscribe')}>Logs souscription</a>
                )
            }
        }

        return <div className="details_section_button">
    
            {emailButton}
            { this.props.devis.synchronized 
                    ? <a className="button" href={this.props.api.downloadDevisUrl(this.props.devis._id.$oid)}>Télécharger le devis</a>
                    : <><img className="working" src={working}/>Devis en coure de modification. <a className={this.state.waiting?'button disabled':'button'} onClick={this.resync.bind(this)}>Recalculer le devis</a></> }
            { this.props.api.isAdmin() ? <a className="button" onClick={this.duplicateDevis.bind(this)}>Dupliquer ce devis pour tester</a> : ''}

            {adminButtons}

        </div>
    }
}
